import './styles/bootstrap.scss';
import { createApp } from 'vue';
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUser, faCheck, faXmark, faEye, faArrowDown, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import App from './App.vue';
import router from './router';
import iam from './iam';

iam.init();
library.add(
  faUser,
  faCheck,
  faXmark,
  faEye,
  faArrowDown,
  faArrowRight);

const app = createApp(App);
app.config.globalProperties.$http = axios;
app.component('font-awesome-icon', FontAwesomeIcon);
app.use(router);
app.mount('#lct');
